const state = {
    checkin: null,
    popupViewed: localStorage.getItem('popupViewed') ? JSON.parse(localStorage.getItem('popupViewed')) : {welcome: [], fixed: []}
}

export const getters = {
    eventBanner: state => state.checkin ? state.checkin.banner : null,
    eventPopup: state => state.checkin ? state.checkin.popup : {welcome: {active: false}, fixed: {active: false}},
    isPopupViewed: state => (type, picaServiceId) => state.popupViewed[type].includes(picaServiceId),
    checkin: state => state.checkin,
    picaServiceId: state => state.checkin ? state.checkin.pica_service_id : null,
    isPromo: state => state.checkin ? state.checkin.is_promo : false,
    isTaggingCompleted: state => state.checkin ? state.checkin.is_tagging_completed : false,
    hdServingType: state => state.checkin ? state.checkin.hd_serving_type : false,
    shareMode: state => state.checkin ? state.checkin.share_mode : null,
    eventName: state => state.checkin ? state.checkin.event_name : '',
    picaCode: state => state.checkin ? state.checkin.picacode : '',
    shareWithFriends: state => state.checkin ? state.checkin.share_with_friends : null,
    useGetPicaForYourEvent: state => state.checkin ? state.checkin.use_pica_for_your_event : null,
    hdAvailableFrom: state => state.checkin ? state.checkin.hd_available_from : null,
    hdAvailableTo: state => state.checkin ? state.checkin.hd_available_to : null,
    mediaAvailableTo: state => state.checkin ? state.checkin.media_available_to : null,
    mediaDeleted: state => state.checkin ? state.checkin.media_deleted : true,
    lastStayDeletionDate: state => state.checkin ? state.checkin.last_stay_deletion_date : null,
    canPurchaseDuringStay: state => state.checkin ? state.checkin.can_purchase_during_stay : null,
    showPrices: state => state.checkin ? state.checkin.show_prices : true,
    canSeeMedia: state => state.checkin ? state.checkin.can_see_media : true,
    currency: state => state.checkin ? state.checkin.currency : null,
    showAllEventPhotos: state => state.checkin ? state.checkin.show_all_event_photos : null,
    allow_user_inference: state => state.checkin ? state.checkin.allow_user_inference : null,
}


export const mutations = {
    set_checkin(state, checkin) {
        state.checkin = checkin
    },
    set_popup_viewed(state, {type, picaServiceId}) {
        state.popupViewed[type].push(picaServiceId)
        localStorage.setItem('popupViewed', JSON.stringify(state.popupViewed))
    },
    unset_event_popup(state) {
        if (state.checkin && state.checkin.pica_service_id) {
            state.checkin.popup = {welcome: {active: false}, fixed: {active: false}};
        }
    },
    clean_popup_viewed(state) {
        state.popupViewed = {welcome: [], fixed: []}
        localStorage.removeItem('popupViewed')
    }
}

export const actions = (eventService) => ({
    async fetchCheckin({commit}, picacode) {
        const response = await eventService.getCheckinDetail(picacode)
        commit('set_checkin', response.data)
    },
    setPopupViewed({commit}, {type, picaServiceId}) {
        commit('set_popup_viewed', {type, picaServiceId})
    },
    unsetEventPopup({commit}) {
        commit('unset_event_popup')
    },
})

export default eventService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(eventService)
})
